export class RangeKm {
    id?: number;
    kmini?: number;
    kmfim?: number;
    valor?: number;

}